import Video from "./Video";
import EndScreen from "./EndScreen";
import Branding from "./Branding";

function Player({ classes = "", attributes }) {
  const { popup, overlay, protected: bProtected, width, radius, endscreen, endscreenText, endscreenTextLink, popupType, popupBtnStyle, popupBtnText, popupBtnExists, popupBtnAlign } = attributes;
  // classes += popup && " h5vp_popup_wrapper popup_close";
  const playerWidth = width.number === 0 ? "100%" : width.number + width.unit;
  const playerRound = radius.number + radius.unit;

  const padding = popupBtnStyle.padding || {};

  return (
    <div className={classes} data-settings={JSON.stringify({})} style={{ width: playerWidth, borderRadius: playerRound, overflow: "hidden" }}>
      {popup && popupType === "button" && !popupBtnExists && (
        <div className="popupBtn" style={{ textAlign: popupBtnStyle.align }}>
          <button style={{ ...popupBtnStyle, padding: `${padding.top} ${padding.right} ${padding.bottom} ${padding.left}` }}>{popupBtnText}</button>
        </div>
      )}
      <div className="sticky_close">&times;</div>
      <div className="popup_close_btn">&times;</div>
      {/* {popup && <Popup poster={poster} />} */}
      {endscreen && <EndScreen buttonText={"Watch Again"} text={endscreenText} link={endscreenTextLink} />}
      {overlay && <Branding attributes={attributes} />}
      <div className="videoWrapper">
        <Video attributes={attributes} />
      </div>
    </div>
  );
}

export default Player;
